<div class="copy-data-div">
  <button mat-icon-button
          #tooltip="matTooltip"
          matTooltip="{{ (isCopying ? 'copied' : 'copy') | translate }}"
          matTooltipClass="big-tooltip"
          (click)="copyDataToClipboard()">
    <mat-icon>file_copy</mat-icon>
  </button>
  {{ params.value }}
</div>
